import axios from "axios";
import getEndpoint from "../getEndpoint";

const ngrokSkipWarning = {headers: {"bypass-tunnel-reminder": "true"} };

type Color = {
  id: string;
  name: string;
  status: string;
}

type ColorDTO = {
  id?: string;
  name: string;
  status: string;
}

export async function GetAllColors() {
  const respone = await axios.get(`${getEndpoint()}/api/Colors/GetAll`, ngrokSkipWarning);
  return respone.data;
}

export async function GetAllColorsOfProduct(id: string){
  const response = await axios.get(`${getEndpoint()}/api/Colors/GetByProductId?id=${id}`, ngrokSkipWarning);
  return response.data;
}

export const addColor = async (colorDTO: ColorDTO) => {
  try {
    const response = await axios.post(`${getEndpoint()}/api/Colors/Add`, colorDTO, ngrokSkipWarning);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const getColor = async (id: string) => {
  try {
    const response = await axios.get(`${getEndpoint()}/api/Colors/Get`, { params: { id }, ...ngrokSkipWarning });
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const updateColor = async (colorDTO: ColorDTO) => {
  try {
    const response = await axios.put(`${getEndpoint()}/api/Colors/Update`, colorDTO, ngrokSkipWarning);
    return response.data;
  } catch (error) {
    throw error;
  }
};

export const deleteColor = async (id: string) => {
  try {
    const response = await axios.delete(`${getEndpoint()}/api/Colors/Delete`, { data: { id }, ...ngrokSkipWarning });
    return response.data;
  } catch (error) {
    throw error;
  }
};